import { feeTypes, periods } from '../../utils';
export var handleClickOnProduct = function handleClickOnProduct(url) {
  window.location.href = url;
};
export { feeTypes, periods };